import type {GetTokens, WorkHit} from './types';
import workQuery from './data/workQuery.json';
import type {SearchSchemas} from './dto.generated';
import {exceptionToPromiseReject} from './exceptionToPromiseReject';
import {httpElasticV2} from './http/search/httpElastic';
import {mapWorkHits} from './mappers/mapWorkHits';
import type {SearchResult, SearchResultDto} from './searchTypes';

export const searchWork = (
  query: string,
  page: number,
  size: number,
  getTokens: GetTokens,
  signal?: AbortSignal,
  includeHachetteWorks?: boolean,
): Promise<SearchResult<WorkHit>> => {
  /**
   * Placed the JSON in a file to easier debug it in elastic cloud console.
   */
  const elasticQuery = JSON.stringify(workQuery)
    .replaceAll('${QUERY_PLACEHOLDER}', query)
    .replaceAll(
      '"${EXCLUDED_PRODUCTOWNERS_PLACEHOLDER}"',
      includeHachetteWorks
        ? '["4252", "4296", "4476"]'
        : '["4252", "4296", "4476", "4253"]', // 4253 is Hachette
    );

  return exceptionToPromiseReject(() =>
    httpElasticV2<SearchResultDto<SearchSchemas.WorkDocument>>(
      getTokens,
      'ebs-work-alias',
      JSON.parse(elasticQuery),
      page,
      size,
      {
        query,
        fields: [
          'preferredTitles',
          'expressions.manifestations.titles.mainTitles.value',
        ],
      },
      signal,
    ).then(mapWorkHits),
  );
};
